// extracted by mini-css-extract-plugin
export default {"group":"style_group__nyZIv","msg":"style_msg__C8pmG"};